module.exports = __webpack_public_path__ + "static/smartstore@3x-61e67c2ceabf9abd5f7f6bc584cd42b6.png";